const STORAGE_KEYS = {
  ACCESS_TOKEN: 'access_token',
  REFRESH_TOKEN: 'refresh_token',
  USER_DATA: 'user_data',
} as const

class TokenService {
  // Save tokens
  async saveTokens(accessToken: string, refreshToken: string): Promise<void> {
    localStorage.setItem(STORAGE_KEYS.ACCESS_TOKEN, accessToken)
    localStorage.setItem(STORAGE_KEYS.REFRESH_TOKEN, refreshToken)
  }

  // Get access token
  async getAccessToken(): Promise<string | null> {
    return localStorage.getItem(STORAGE_KEYS.ACCESS_TOKEN)
  }

  // Get refresh token
  async getRefreshToken(): Promise<string | null> {
    return localStorage.getItem(STORAGE_KEYS.REFRESH_TOKEN)
  }

  // Clear all tokens
  async clearTokens(): Promise<void> {
    localStorage.removeItem(STORAGE_KEYS.ACCESS_TOKEN)
    localStorage.removeItem(STORAGE_KEYS.REFRESH_TOKEN)
    localStorage.removeItem(STORAGE_KEYS.USER_DATA)
  }

  // Save user data
  async saveUserData(userData: any): Promise<void> {
    localStorage.setItem(STORAGE_KEYS.USER_DATA, JSON.stringify(userData))
  }

  // Get user data
  async getUserData(): Promise<any | null> {
    const data = localStorage.getItem(STORAGE_KEYS.USER_DATA)
    return data ? JSON.parse(data) : null
  }
}

export const tokenService = new TokenService()
